<template>
  <div class="sector-list">
    <span class="sector-title">Planificación por Sectores</span>
    <el-tooltip>
      <div class="info-sector"
           slot="content">
        <p><i class="el-icon-place"/> : Rutas de sector visibles en la lista</p>
        <p><i class="el-icon-full-screen"/> : Rutas de sector ocultas en la lista</p>
      </div>
      <i class="el-icon-info"/>
    </el-tooltip>
    <div class="semi-card-holder">
      <SectorItem v-for="(sector, index) in sectors"
                  :key="sector.id"
                  v-model="sectors[index]"/>
    </div>
  </div>
</template>

<script>
import SectorItem from './Item.vue';

export default {
  props: {
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: 'SectorList',
  components: {
    SectorItem,
  },
};
</script>

<style lang="scss">
  .info-sector p {
    margin: 4px 5px;
    i { margin-right: 4px; }
  }
  .sector-list {
    text-align: left;
    width: 100%;
    margin: -10px 0 15px;
    .sector-title{
      color: #aad500;
      font-size: 12px;
      font-weight: 900;
      margin: 0 4px 0 7px;
      line-height: 20px;
      text-transform: uppercase;
    }
    .el-icon-info { font-size: 13px; }
    .semi-card-holder {
      padding: 5px;
      background-color: #fafafa;
      border-radius: 3px;
      box-shadow: inset 0 0 5px 0 rgba(0, 0, 0, 0.1);
      margin: 0 5px 5px 5px;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
    }
  }
</style>
